import { render } from "./DashboardHeader.vue?vue&type=template&id=27cfaabd&scoped=true&ts=true"
import script from "./DashboardHeader.vue?vue&type=script&lang=ts"
export * from "./DashboardHeader.vue?vue&type=script&lang=ts"

import "./DashboardHeader.vue?vue&type=style&index=0&id=27cfaabd&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cfaabd"]])

export default __exports__